import { Stack, Typography } from '@mui/material';
import { useCallback, useState } from 'react';

import { Icon, Modal } from '@hapvida/hapvida-core-components';

import { useBeneficiaryServices } from '../../../../hooks/useBeneficiaryServices';
import { RESOURCES_SERVICE_AUTHORIZATION } from '../../constants/resources';
import { StyledButton } from './styles';
import { type BeneficiaryServiceRedirectProps } from './types';

export function BeneficiaryServiceRedirect({
  serviceAuthorized,
  beneficiaryCode,
  name,
}: Readonly<BeneficiaryServiceRedirectProps>) {
  const [isOpenModalState, setIsOpenModalState] = useState(false);

  const {
    beneficiariesServiceRedirect: { data: redirectUrl, isLoading, isError },
  } = useBeneficiaryServices(beneficiaryCode, isOpenModalState);

  const handleRedirect = useCallback(() => {
    if (redirectUrl && typeof redirectUrl === 'string') {
      window.open(redirectUrl, '_blank');
    }
  }, [redirectUrl]);

  const { labelText, rowColor, cursor, title } = serviceAuthorized
    ? RESOURCES_SERVICE_AUTHORIZATION.authorized
    : RESOURCES_SERVICE_AUTHORIZATION.unauthorized;

  const handleButtonClick = () => {
    if (serviceAuthorized) {
      setIsOpenModalState(true);
    }
  };

  return (
    <Stack gap={1} flexDirection="row" alignItems="center" title={title}>
      <StyledButton
        cursor={cursor}
        onClick={handleButtonClick}
        disabled={!serviceAuthorized}
      >
        <Typography variant="text" fontWeight={700} color={rowColor}>
          {labelText}
        </Typography>
      </StyledButton>
      <Icon size={16} color={rowColor} name="actions-b2b-open-in-new" />
      <Modal
        open={isOpenModalState}
        icon="actions-b2b-alert-octagon-filled"
        type="default"
        handleCloseModal={() => setIsOpenModalState(false)}
        title="Serviços de beneficiário"
        mainButtonText="Acessar portal"
        secondaryButtonText="Fechar"
        mainAction={handleRedirect}
        loading={isLoading}
        disableMainAction={isError}
      >
        <Typography variant="text">
          Deseja realmente acessar o Portal do Beneficiário como “
          <Typography variant="text" fontWeight={700}>
            {name}
          </Typography>
          ”?
        </Typography>
      </Modal>
    </Stack>
  );
}
